import React, { memo, useMemo } from 'react'

import { Td } from 'Components/Table/Td'
import { Tr } from 'Components/Table/Tr'
import { getReadableDateTimeStringFromISO } from 'shared/libraries/utils/date'

export default memo(props => {
  const {
    dateTime,
    quantity,
    comments,
    tag,
    cityId,
    relatedUserId,
    relatedUserName,
    relatedMissionId,
    relatedCityId,
    relatedCityName,
  } = props

  const readableDateTimeString = useMemo(() =>
    getReadableDateTimeStringFromISO(dateTime),
  )

  return (
    <Tr>
      <Td>{readableDateTimeString}</Td>
      <Td>{quantity}</Td>
      <Td>{tag}</Td>
      <Td>{comments}</Td>
      <Td>
        <RelatedUserLink
          relatedUserId={relatedUserId}
          relatedUserName={relatedUserName}
          cityId={cityId}
        />
      </Td>
      <Td>
        <RelatedMissionLink relatedMissionId={relatedMissionId} />
      </Td>
      <Td>
        <RelatedCityLink
          relatedCityId={relatedCityId}
          relatedCityName={relatedCityName}
        />
      </Td>
    </Tr>
  )
})

const RelatedUserLink = memo(({ relatedUserId, relatedUserName, cityId }) => {
  if (!relatedUserId) return null
  return (
    <a
      href={`/dashboard/cities/${cityId}/ambassadors/${relatedUserId}`}
      target="_blank"
    >
      {relatedUserName}
    </a>
  )
})

const RelatedMissionLink = memo(({ relatedMissionId }) => {
  if (!relatedMissionId) return null
  return (
    <a href={`/dashboard/mission/${relatedMissionId}`} target="_blank">
      Link
    </a>
  )
})

const RelatedCityLink = memo(({ relatedCityId, relatedCityName }) => {
  if (!relatedCityId) return null
  return (
    <a href={`/dashboard/cities/${relatedCityId}`} target="_blank">
      {relatedCityName || 'id: ' + relatedCityId}
    </a>
  )
})



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Movements/components/InventoryMovements/Row/index.js